/**
 * Join Community Section
 * JavaScript for form validation and interactions
 */

(function() {
  'use strict';

  const validators = {
    required: function(value) {
      return value.trim() !== '';
    },
    email: function(value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    }
  };

  const errorMessages = {
    required: 'This field is required',
    email: 'Please enter a valid email address'
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Find all join community forms on the page
    const forms = document.querySelectorAll('.join-community__form-inner');
    
    forms.forEach(form => {
      const fieldWrapper = form.querySelector('.join-community__email-field[data-validate]');

      if (!fieldWrapper) {
        return;
      }

      const input = fieldWrapper.querySelector('.input, input[type="email"]');

      if (!input) {
        return;
      }

      // Real-time validation
      input.addEventListener('blur', () => {
        validateField(fieldWrapper);
      });

      input.addEventListener('input', () => {
        if (fieldWrapper.classList.contains('is-invalid')) {
          validateField(fieldWrapper);
        }
      });

      // Form submit validation
      form.addEventListener('submit', (event) => {
        // Clear previous state
        fieldWrapper.classList.remove('is-invalid', 'is-valid');

        if (!validateField(fieldWrapper)) {
          event.preventDefault();

          const targetInput = fieldWrapper.querySelector('.input, input[type="email"]');
          if (targetInput) {
            targetInput.focus();
          }
        }
      });
    });
  }

  function validateField(fieldWrapper) {
    const validateAttr = fieldWrapper.getAttribute('data-validate');
    if (!validateAttr) return true;

    const input = fieldWrapper.querySelector('.input, input[type="email"]');
    if (!input) return true;

    const rules = validateAttr.split('|');
    const value = input.value || '';

    let isValid = true;
    let errorMessage = '';

    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i].trim();
      const validator = validators[rule];

      if (validator && !validator(value)) {
        isValid = false;
        errorMessage = errorMessages[rule] || '';
        break;
      }
    }

    const errorElement = fieldWrapper.querySelector('.join-community__field-error');

    if (isValid) {
      fieldWrapper.classList.remove('is-invalid');
      fieldWrapper.classList.add('is-valid');
      if (errorElement) {
        errorElement.textContent = '';
      }
    } else {
      fieldWrapper.classList.remove('is-valid');
      fieldWrapper.classList.add('is-invalid');
      if (errorElement) {
        errorElement.textContent = errorMessage;
      }
    }

    return isValid;
  }
})();

